import {Message} from 'element-ui'
import axios from 'axios';
import {jsonToFormData} from "@/utils/index";
import router from '@/router';
import Language from "@/utils/language";

//   axios.defaults.baseURL = 'http://47.107.234.15:18080/battery_admin';
//   axios.interceptors.request.use(function (config) {
//     let token = sessionStorage.getItem("token")
//     config.headers['access-token']=token
//     console.log(config)
//     return config;
//   }, function (error) {
//   return Promise.reject(error);
// });
function wrapText(text, maxLength = 1000) {

  let d= text.length <= maxLength ? text : `${text.substring(0, maxLength)}...`;
  return d
}


function handleExport(res) {

  if(res.headers['content-type']==='application/json;charset=UTF-8'){
    console.log(res.data)

    let reader = new FileReader();
    reader.onload = function(event){

      let res = JSON.parse(reader.result);
      if (res && res.code != 0) {
        let text = res.data
        if (text == null) {
          text = res.message
          if (text == null) {
            text = '服务器繁忙！'
          }
        }
        Message({
          message: text,
          type: 'warning',
          duration: 5000,
          showClose: true
        })
        return null
      }
    };
    reader.readAsText(res.data);
    return;


  }
  let fileName=res.headers['content-disposition'];
  if(!fileName){
    fileName="excel";
  }else{
    fileName=fileName.substring("attachment;filename* = UTF-8''".length,fileName.length)
  }
  download(res.data,decodeURIComponent(fileName))
}



export function getExcelByPostJSON(url, params,config  = {handleError: true}) {
  let requestBody={};
  if(Array.isArray(params)){
    requestBody=params;
  }else{

    Object.keys(params).forEach((item,i)=>{
      if( params[item]===undefined ||  params[item]===null ||  params[item]===""  || (Array.isArray( params[item]) &&  params[item].length===0)){ //过来undefine
        return
      }
      requestBody[item]= params[item];
    })
  }
  return axios({
    url: url,
    method: 'POST',
    data: requestBody,
    responseType: 'blob', //二进制流
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    ...config

  }).then(handleExport).catch(function (error) {
    if(error.message.indexOf("timeout")!=-1){
      Message({
        message: "数据量过大，导出失败！",
        type: 'error',
        duration: 2000,
        offset:80,
        showClose: true
      })
    }
    console.log(error)
  });
}

export function  request(params) {
  return axios(params).then((res)=>{
    //如果404之类的，可以统一处理
    return res.data;
  }).then(res=>{
    if(res && res.code!=0){
      let data= res.data;
      if(!data){
         data=res.message;
        if(!data){
          data="服务器繁忙";
        }

      }

      Message({
        message: wrapText(data),
        type: "warning",
        duration: 5000,
        offset: 80,
      });
      if(res.data=='登录已经失效 请重新登录'){
        router.push({ name: "login" });
      }
      return null;
    }
    return res;
  })
}



export function get(url, params) {
  return request({
    url: url+(params!==undefined?"?"+jsonToFormData(params):""),
    methods: "get"
  })
}

export function deleteRequest(url, params) {
  return request({
    url: url + (params != undefined ? '?' + jsonToFormData(params) : ''),
    method: 'delete',
  })
}

export function postForm(url, params) {
  return request({
    url: url,
    method: 'POST',
    data: jsonToFormData(params),
    contentType: "application/x-www-form-urlencoded;charset=utf-8"
  });
}


// export function getExcel(url, params, fileName) {
//   window.location.href=axios.defaults.baseURL+"/"+url + (params ? '?' + jsonToFormData(params):"");
// }


//下载文件
function download(data,fileName) {
  if(!data){
    return
  }
  let blob = new Blob([data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'})
  let url = window.URL.createObjectURL(blob);
  let aLink = document.createElement("a");
  aLink.style.display = "none";
  aLink.href = url;
  aLink.setAttribute("download", fileName);
  document.body.appendChild(aLink);
  aLink.click();
  document.body.removeChild(aLink); //下载完成移除元素
  window.URL.revokeObjectURL(url); //释放掉blob对象
}

//下载文本
function downloadText(data,fileName) {
  if(!data){
    return
  }
  let blob = new Blob([data], {type: 'text/plain;charset=utf-8'})
  let url = window.URL.createObjectURL(blob);
  let aLink = document.createElement("a");
  aLink.style.display = "none";
  aLink.href = url;
  aLink.setAttribute("download", fileName);
  document.body.appendChild(aLink);
  aLink.click();
  document.body.removeChild(aLink); //下载完成移除元素
  window.URL.revokeObjectURL(url); //释放掉blob对象
}
export function getExcel(url, params,boolText='') {
  axios.get(url, {
    timeout: 30*1000,
    params:params,
    responseType: 'blob', //二进制流
  }).then(function (res) {
    if(res.headers['content-type']==='application/json;charset=UTF-8'){
      console.log(res.data)

      let reader = new FileReader();
      reader.onload = function(event){

        let res = JSON.parse(reader.result);
        if (res && res.code != 0) {
          let text = res.data
          if (text == null) {
            text = res.message
            if (text == null) {
              text = '服务器繁忙！'
            }
          }
          Message({
            message: text,
            type: 'warning',
            duration: 5000
          })
          return null
        }
      };
      reader.readAsText(res.data);
      return;


    }

    let fileName=res.headers['content-disposition'];
    if(boolText=='1'){
      if(!fileName){
        fileName="output";
      }else{
        fileName= fileName.substring(fileName.indexOf("filename=")+'filename='.length)
      }

      downloadText(res.data,decodeURIComponent(fileName))
    }else {
      if(!fileName){
        fileName="excel";
      }else{
        fileName=fileName.substring("attachment;filename* = UTF-8''".length,fileName.length)
      }
      download(res.data,decodeURIComponent(fileName))
    }


  }).catch(function (error) {
    // console.log(error.error)
    // console.log(String(error));
    // console.log(error.message);
    // debugger
     if(error.message.indexOf("timeout")!=-1){
       Message({
         message:Language.convert('数据量过大，导出失败！'),
         type: 'error',
         duration: 2000,
         offset:80
       })
     }
    console.log(error)
  });


  // window.location.href=axios.defaults.baseURL+"/"+url + (params ? '?' + jsonToFormData(params):"");

}

export function  postFormData(url,params) {
  let requestBody=new FormData();
  Object.keys(params).forEach((item,i)=>{
    if( params[item]===undefined ||  params[item]===null ||  params[item]==""){
      return
    }
    requestBody.append(item,params[item]);
  });

  return request({
    url: url,
    method: 'POST',
    data: requestBody,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
}

export function postJSON(url, params) {
  let requestBody={};
  if(Array.isArray(params)){
    requestBody=params;
  }else{

    Object.keys(params).forEach((item,i)=>{
      if( params[item]===undefined ||  params[item]===null ||  params[item]===""){ //过来undefine
        return
      }
      requestBody[item]= params[item];
    })
  }

  return request({
    url: url,
    method: 'POST',
    data: requestBody,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }

  });
}


export function postPayload(url, params) {


  return request({
    url: url,
    method: 'POST',
    data: params,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }

  });
}

export function putJSON(url, params) {
  let requestBody={};
  Object.keys(params).forEach((item,i)=>{
    if( params[item]===undefined ||  params[item]===null ||  params[item]===""){ //过来undefine
      return
    }
    requestBody[item]= params[item];
  })
  return request({
    url: url,
    method: 'put',
    data: requestBody,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }

  });
}





// WEBPACK FOOTER //
// ./src/utils/request.js